import React, { useState } from "react";
import {
  EuiBadge,
  EuiPopover,
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton,
  EuiLink,
  EuiSpacer,
  EuiIcon,
  EuiPanel,
} from "@elastic/eui";
import { GitLabTag } from "src/questionnaires";
import { GitLabUserAvatar } from "./avatar";
import { useAnketaI18n } from "src/internationalization";

export const GitLabTagPopover = ({ tag }: { tag: GitLabTag }): JSX.Element => {
  const { translate } = useAnketaI18n();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const togglePopover = () => setIsPopoverOpen(!isPopoverOpen);
  const closePopover = () => setIsPopoverOpen(false);

  return (
    <EuiPopover
      button={
        <EuiButton onClick={togglePopover} iconType="tag">
          {tag.name}
          {tag.protected && (
            <EuiBadge color="hollow" style={{ marginLeft: 8 }}>
              {translate("anketa.opsanio.gitlab.tag.protected", {
                defaultMessage: "Protected",
              })}
            </EuiBadge>
          )}
        </EuiButton>
      }
      isOpen={isPopoverOpen}
      closePopover={closePopover}
      panelPaddingSize="m"
    >
      <EuiFlexGroup direction="column" gutterSize="m" style={{ minWidth: 340 }}>
        <EuiFlexItem>
          <EuiText>
            <h4>
              <EuiIcon type="gitCommit" />{" "}
              {translate("anketa.opsanio.gitlab.tag.commit.heading", {
                defaultMessage: "Commit",
              })}
            </h4>
          </EuiText>
          <EuiFlexGroup gutterSize="s" alignItems="center">
            <EuiFlexItem grow={false}></EuiFlexItem>
            <EuiFlexItem>
              <EuiPanel>
                <EuiText size="s">
                  <p>
                    <GitLabUserAvatar
                      user={{
                        id: 0,
                        username: tag.commit.committer_email,
                        public_email: tag.commit.committer_email,
                        name: tag.commit.committer_name,
                        state: "active",
                        locked: false,
                        avatar_url: tag.commit.author_email,
                        web_url: "",
                      }}
                    />{" "}
                    {translate("anketa.opsanio.gitlab.tag.committed", {
                      defaultMessage: "committed",
                    })}{" "}
                    <EuiLink href={(tag.commit as any).web_url} target="_blank">
                      {tag.commit.title}
                    </EuiLink>
                  </p>
                  <EuiText size="xs" color="subdued">
                    {tag.commit.message}
                  </EuiText>
                </EuiText>
              </EuiPanel>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        {tag.release && (
          <EuiFlexItem>
            <EuiSpacer size="s" />
            <EuiText>
              <h4>
                <EuiIcon type="package" />{" "}
                {translate("anketa.opsanio.gitlab.tag.release.heading", {
                  defaultMessage: "Release",
                })}
              </h4>
            </EuiText>
            <EuiFlexGroup gutterSize="s" alignItems="center">
              <EuiFlexItem grow={false}>
                <EuiBadge iconType="tag">{tag.release.tag_name}</EuiBadge>
              </EuiFlexItem>
              <EuiFlexItem>
                <EuiText size="s">{tag.release.description}</EuiText>
              </EuiFlexItem>
            </EuiFlexGroup>
          </EuiFlexItem>
        )}
      </EuiFlexGroup>
    </EuiPopover>
  );
};
